<div class="control-container">
    <div class="email-control">
        <form
            [formGroup]="form"
            (submit)="addEmails()"
            class="invite-input-container"
            autocomplete="off"
        >
            <label for="emails">
                {{
                    'client-admin.users.invite-users.email-address' | translate
                }}
            </label>
            <input
                formControlName="emails"
                id="emails"
                type="text"
                [matAutocomplete]="auto"
                matAutocompletePosition="below"
                [disabled]="disabled"
                (focusout)="handleFocusOut()"
            />
            <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="handleOptionSelected($event)"
            >
                @for (item of typeaheadList$ | async; track item) {
                    <mat-option
                        class="mat-autocomplete-option"
                        [value]="item"
                        [disabled]="doesUserAlreadyExist(item)"
                    >
                        {{ item | emailAutocompleteDisplay }}
                        @if (doesUserAlreadyExist(item)) {
                            <span class="mat-autocomplete-already-added">{{
                                'alreadyadded' | translate
                            }}</span>
                        }
                    </mat-option>
                }
            </mat-autocomplete>
        </form>
        @if (showCounter) {
            <div class="email-chips-counter">
                <span>{{ emails | emailCounter: maximumEntries }}</span>
            </div>
        }
    </div>
    <ng-content select="[formRow]"></ng-content>
</div>
<div class="email-chips-container">
    <tapestry-chip-list>
        @for (entity of emails; track entity) {
            <tapestry-chip
                [color]="emailChipColor"
                [class.invalid]="!entity.valid"
            >
                {{ entity | emailChipDisplay }}
                <button (click)="removeEmail(entity)">
                    <tapestry-icon name="close_page"></tapestry-icon>
                </button>
            </tapestry-chip>
        }
    </tapestry-chip-list>
</div>

@if (validationErrors.length > 0) {
    <div class="validation-error-container">
        @for (error of validationErrors; track error) {
            <tapestry-inline-message-box
                [content]="error.message"
                type="tapestry-inline-message-box--error"
            ></tapestry-inline-message-box>
        }
    </div>
}
